import { styled } from "styled-components";
import BlogArticleCard from "../components/BlogArticleCard";
import TestimonialSection from "../components/common/TestimonialSection";
import { blogArticles } from "../lib/blogData";
import { useTestimonials } from "../hooks/useTestimonials";
import PartnersContainer from "../components/common/PartnersContainer";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
`;

const ContentArea = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 36px 60px 64px;
  width: 100%;
  min-height: calc(100vh - 72px);
  box-sizing: border-box;

  @media (max-width: 1023px) {
    padding: 30px 40px 54px;
    min-height: calc(100vh - 64px);
  }

  @media (max-width: 767px) {
    padding: 20px 20px 38px;
    min-height: calc(100vh - 56px);
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1320px;
`;

const PageTitle = styled.h1`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 700;
  font-size: 44px;
  line-height: 1.05;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px;
  border-radius: 28px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid rgba(10, 17, 41, 0.06);
  box-shadow: 0 18px 48px rgba(13, 18, 45, 0.08);

  @media (max-width: 767px) {
    padding: 14px;
    border-radius: 24px;
  }
`;

const ArticlesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Blog = () => {
  const { data: testimonials = [] } = useTestimonials();

  return (
    <PageContainer>
      <ContentArea>
        <ContentRow>
          <MainContent>
            <PageTitle>Blog</PageTitle>
            <MainPanel>
              <ArticlesList>
                {blogArticles.map((article, index) => (
                  <BlogArticleCard
                    key={article.id}
                    id={article.id}
                    index={index + 1}
                    title={article.title}
                    excerpt={article.excerpt}
                    imageUrl={article.imageUrl}
                  />
                ))}
              </ArticlesList>
            </MainPanel>
          </MainContent>
        </ContentRow>
      </ContentArea>

      <TestimonialSection testimonials={testimonials} />
      <PartnersContainer />
    </PageContainer>
  );
};

export default Blog;
